import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { flowRight as compose } from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Grid from 'react-bootstrap/lib/Grid';
import { FormattedMessage, injectIntl } from 'react-intl';

import Loader from '../../Loader/Loader';
import PopularLocationGridItem from '../PopularLocationGridItem';

import { locationuploadDir } from '../../../config';
import { isRTL } from '../../../helpers/formatLocale';
import { photosShow } from '../../../helpers/photosShow';
import { SampleNextArrow, SamplePrevArrow } from '../../../helpers/swiper';
import messages from '../../../locale/messages';
import SeeAll from '../../Home/SeeAll';

import cs from 'swiper/swiper-bundle.css';
import t from '../../../styles/customSwiper.css';
import s from './PopularLocationGrid.css';

const PopularLocationGrid = ({ data = [], intl: { locale }, loading }) => {
  const [isClient, setIsClient] = useState(false);
  const [load, setLoad] = useState(true);
  const [swiper, setSwiper] = useState(null);
  const [modules, setModules] = useState(null);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setSwiper(require('swiper/react'));
      setModules(require('swiper/modules'));
      setIsClient(true);
    }
  }, []);

  useEffect(() => {
    let timeout;
    setLoad(false);
    timeout = setTimeout(() => setLoad(true), 1);
    return () => clearTimeout(timeout);
  }, [locale]);

  if (!swiper || !modules) return null;

  const { Swiper, SwiperSlide } = swiper;
  const { Navigation } = modules;

  const params = {
    modules: [Navigation],
    navigation: {
      nextEl: `.popularLocationSwiperNavigationNextBtn`,
      prevEl: `.popularLocationSwiperNavigationPrevBtn`,
    },
    slidesPerView: 1,
    spaceBetween: 15,
    breakpoints: {
      320: { slidesPerView: 1 },
      641: { slidesPerView: 2 },
      768: { slidesPerView: 3 },
      991: { slidesPerView: 6 },
      //  if change breakpoint also change skeleton css breakpoint in app-common.css
    }
  };

  const path = photosShow(locationuploadDir);

  return (
    <Grid fluid>
      <div className={cx(s.GridCollapse)}>
        {
          !load && !isClient && <Loader type="text" />
        }
        {
          load && isClient && data.length > 0 &&
          <div className={s.sliderHeadingFlex}>
            <h3 className={cx(s.containerTitle,)}>
              <FormattedMessage {...messages.popularLocation} />
              <span className={s.highlight}>en Bolivia</span>
            </h3>
            <SeeAll />
          </div>
        }
        {
          load && isClient &&
          <div className={s.popularLocationSwiperContainer}>
            <Swiper {...params} rtl={isRTL(locale)} className={cx('row homeSlickSlider', s.noMargin)}>
              {data.map((item, index) => (
                item.isEnable === 'true' && (
                  <SwiperSlide key={index}>
                    <PopularLocationGridItem
                      id={item.id}
                      location={item.location}
                      image={item.image}
                      locationAddress={item.locationAddress}
                      path={path + item.image}
                    />
                  </SwiperSlide>
                )
              ))}
            </Swiper>
            <SamplePrevArrow className={cx(s.displayNone, 'popularLocationSwiperNavigationPrevBtn')} />
            <SampleNextArrow className={cx(s.displayNone, 'popularLocationSwiperNavigationNextBtn')} />
          </div>
        }
      </div>
    </Grid>
  );
};

PopularLocationGrid.propTypes = {
  loading: PropTypes.bool,
  data: PropTypes.array,
  intl: PropTypes.object.isRequired
};

export default compose(
  injectIntl,
  withStyles(cs, s, t),
)(PopularLocationGrid);
